import { useEffect, useRef } from 'react';

import type { ErrorLike } from '@apollo/client';

export const needsRefetchFor = (
  id: string | null | undefined,
  options: ReadonlyArray<{ id: string }> | null | undefined,
  refetchedIds: ReadonlySet<string>,
): id is string =>
  id != null &&
  options != null &&
  !refetchedIds.has(id) &&
  !options.some(option => option.id === id);

export const useRefetchWhenMissing = (
  id: string | null | undefined,
  options: ReadonlyArray<{ id: string }> | null | undefined,
  refetch: () => Promise<unknown>,
  onError: (error: ErrorLike) => void,
) => {
  const refetchedIdsRef = useRef(new Set<string>());
  useEffect(() => {
    if (!needsRefetchFor(id, options, refetchedIdsRef.current)) {
      return;
    }
    refetchedIdsRef.current.add(id);
    void refetch().catch(onError);
  }, [id, options, refetch, onError]);
};
